import React, { Fragment, useState } from 'react';
import { Button, Form, Alert, FloatingLabel, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import SaudeService from '../../../../../services/saude-auth';



const Remume = () => {
    const [nome, setNome] = useState("");
    const [composicao, setComposicao] = useState("");
    const [apresentacao, setApresentacao] = useState("");
    const [disponibilidade, setDisponibilidade] = useState("");
    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState(false);


    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const med = await SaudeService.cadastroRemume({
                nome: nome,
                composicao: composicao,
                apresentacao: apresentacao,
                disponibilidade: disponibilidade
            })
            if (med.data["_id"]) {
                alert("Medicamento cadastrado com sucesso!")
                setSucesso(true);
            }
            else {
                alert(med.data["error"]);
            }
        } catch (error) {
            console.log(error)
        }
    }

    const addNovo = (evt) => {
        evt.preventDefault()
        setSucesso(false)
        setNome("");
        setComposicao("");
        setApresentacao("");
        setDisponibilidade("");
        setError([]);
    }

    if (!sucesso) {
        return (
            <Fragment>
                <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                    <Row xs={1} lg={2}>
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="nome">
                                <FloatingLabel
                                    label="Medicamento"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="nome"
                                        value={nome}
                                        onChange={e => setNome(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="composicao">
                                <FloatingLabel
                                    label="Composição/Concentração"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="composicao"
                                        value={composicao}
                                        onChange={e => setComposicao(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="apresentacao">
                                <FloatingLabel
                                    label="Apresentação"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="apresentacao"
                                        value={apresentacao}
                                        onChange={e => setApresentacao(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="Disponibilidade">
                                <FloatingLabel
                                    label="Disponível?"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Disponibilidade"
                                        name="disponibilidade"
                                        onChange={e => setDisponibilidade(e.target.value)}
                                    >
                                        <option>SELECIONE</option>
                                        <option value="Com estoque">Com estoque</option>
                                        <option value="Sem estoque">Sem estoque</option>
                                        <option value="Aguardando chegada">Aguardando chegada</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                    </Row>
                    {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                    <Button variant="primary" type="submit">
                        Cadastrar
                    </Button>
                </Form >
                <br />
                <Link to={'/restrito/saude/remume'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Medicamento cadastrado com sucesso!</Alert>
                <Button onClick={addNovo} variant="success" type="submit">
                    Adicionar outro
                </Button>
                <br /><br />
                <Link to={'/restrito/saude/remume/listar'}>
                    <Button variant="primary" type="button">
                        Ir para Listagem de Medicamentos
                    </Button>
                </Link>
                <br /><br />
                <Link to={'/restrito/saude/remume'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment>
        )
    }
}

export default Remume;